import { IFundingRequestItems } from '@/modules/funding-request-field/funding-request-field.model'

export const fundingRequestItemsPrivate: IFundingRequestItems[] = [
  {
    label: 'Paraiškos teikėjas',
    items: [
      {
        key: 'first_name',
        type: 'string',
        group: 'group-main',
        label: 'Vardas',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'last_name',
        type: 'string',
        group: 'group-main',
        label: 'Pavardė',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'person_code',
        type: 'number',
        group: 'group-main',
        label: 'Asmens kodas',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'income_sources',
        type: 'json',
        group: 'group-main',
        label: 'Pajamos',
        options: [
          {
            type: 'multi_select',
            label: 'Veikla',
            value: 'income_type',
            options: [
              {
                label: 'Nuolatinis darbas',
                value: 'work',
              },
              {
                label: 'Darbas užsienyje',
                value: 'work_abroad',
              },
              {
                label: 'Statutinis pareigūnas',
                value: 'statutory_officer',
              },
              {
                label: 'Individuali veikla',
                value: 'self_employment',
              },
              {
                label: 'Kita',
                value: 'other',
              },
            ],
            required: 1,
          },
          {
            type: 'number',
            label: 'Pajamos per mėnesį',
            value: 'monthly_income',
            required: 1,
          },
          {
            type: 'multi_select',
            label: 'Išdirbtas laikotarpis',
            value: 'work_experience',
            options: [
              {
                label: 'Iki 4mėn.',
                value: 'four_month',
              },
              {
                label: '4-6 mėn.',
                value: 'six_month',
              },
              {
                label: 'Nuo 6 mėn iki 1 metų.',
                value: 'one_year',
              },
              {
                label: 'Virš 1 metų.',
                value: 'over_one_year',
              },
            ],
            required: 1,
          },
        ],
        visibleByRoleSlug: null,
      },
      {
        key: 'spouse_income_sources',
        type: 'json',
        group: 'group-main',
        show_if: 'is_married',
        label: 'Sutuoktinio pajamos',
        options: [
          {
            type: 'multi_select',
            label: 'Veikla',
            value: 'income_type',
            options: [
              {
                label: 'Nuolatinis darbas',
                value: 'work',
              },
              {
                label: 'Darbas užsienyje',
                value: 'work_abroad',
              },
              {
                label: 'Statutinis pareigūnas',
                value: 'statutory_officer',
              },
              {
                label: 'Individuali veikla',
                value: 'self_employment',
              },
              {
                label: 'Kita',
                value: 'other',
              },
            ],
            required: 1,
          },
          {
            type: 'number',
            label: 'Pajamos per mėnesį',
            value: 'monthly_income',
            required: 1,
          },
          {
            type: 'multi_select',
            label: 'Išdirbtas laikotarpis',
            value: 'work_experience',
            options: [
              {
                label: 'Iki 4mėn.',
                value: 'four_month',
              },
              {
                label: '4-6 mėn.',
                value: 'six_month',
              },
              {
                label: 'Nuo 6 mėn iki 1 metų.',
                value: 'one_year',
              },
              {
                label: 'Virš 1 metų.',
                value: 'over_one_year',
              },
            ],
            required: 1,
          },
        ],
        visibleByRoleSlug: null,
      },
      {
        key: 'have_financial_liabilities',
        type: 'checkbox',
        group: 'group-main',
        label: 'Ar turite įsipareigojimų finansinėms institucijoms?',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'financial_liabilities',
        type: 'number',
        group: 'group-main',
        label: 'Įsipareigojimų suma',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'is_financial_liabilities_grows_next_month',
        type: 'checkbox',
        group: 'group-main',
        label: 'Ar planuojate, kad kitą mėnesį įsipareigojimai didės?',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'financial_liabilities_growth',
        type: 'number',
        group: 'group-main',
        label: 'Įsipareigojimų didėjimas nuo kito mėn.',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'is_politically_important_person',
        type: 'checkbox',
        group: 'group-main',
        label:
          'Ar Jūs, Jūsų šeimos nariai arba artimi pagalbininkai šiuo metu eina, ar per pastaruosius 12 mėn. ėjo svarbias pareigas LR, ES, tarptautinėse, ar užsienio institucijose?',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'have_children',
        type: 'checkbox',
        group: 'group-main',
        label: 'Ar turite nepilnamečių vaikų?',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'children',
        type: 'number',
        group: 'group-main',
        label: 'Nepilnamečių vaikų skaičius',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'funding_type',
        type: 'text',
        group: 'group-shared',
        label: 'Paskolos paskirtis',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'description',
        type: 'text',
        group: 'group-shared',
        label: 'Aprašymas',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'email',
        type: 'text',
        group: 'group-main',
        label: 'El. paštas',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'phone',
        type: 'text',
        group: 'group-main',
        label: 'Telefonas',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'education',
        type: 'select',
        group: 'group-main',
        label: 'Išsilavinimas',
        options: [
          {
            label: 'Nebaigtas vidurinis',
            value: 'none',
          },
          {
            label: 'Vidurinis',
            value: 'basic',
          },
          {
            label: 'Aukštentysis',
            value: 'college',
          },
          {
            label: 'Aukštasis',
            value: 'university',
          },
        ],
        visibleByRoleSlug: null,
      },
      {
        key: 'future_income',
        type: 'number',
        group: 'group-main',
        label: 'Kokios pajamos numatomos ateityje?',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'residence_type',
        type: 'select',
        group: 'group-main',
        label: 'Gyvenamosios vietos tipas',
        options: [
          {
            label: 'Namas',
            value: 'house',
          },
          {
            label: 'Butas',
            value: 'flat',
          },
          {
            label: 'Nuomojamas butas',
            value: 'rental-flat',
          },
          {
            label: 'Su tėvais',
            value: 'parent-residence',
          },
          {
            label: 'Bendrabutis',
            value: 'dorm',
          },
        ],
        visibleByRoleSlug: null,
      },
      {
        key: 'property',
        type: 'select',
        group: 'group-main',
        label: 'Turimas nekilnojamas turtas',
        options: [
          {
            label: 'Neturi',
            value: 'none',
          },
          {
            label: 'Namas',
            value: 'house',
          },
          {
            label: 'Butas',
            value: 'flat',
          },
          {
            label: 'Automobilis',
            value: 'vehicle',
          },
        ],
        visibleByRoleSlug: null,
      },
      {
        key: 'district',
        type: 'string',
        group: 'group-main',
        label: 'Rajonas',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'city',
        type: 'string',
        group: 'group-main',
        label: 'Miestas, miestelis, kaimas',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'street',
        type: 'string',
        group: 'group-main',
        label: 'Gatvė, namas, butas',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'address_zip_code',
        type: 'string',
        group: 'group-main',
        label: 'Pašto kodas',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'address_street',
        type: 'string',
        group: 'group-main',
        label: 'Gatvė',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'address_house_number',
        type: 'string',
        group: 'group-main',
        label: 'Namo nr.',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'address_flat_number',
        type: 'string',
        group: 'group-main',
        label: 'Buto nr.',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'family_type',
        type: 'select',
        group: 'group-main',
        label: 'Šeimyninė padėtis',
        options: [
          {
            label: 'Vedęs/Ištekėjusi',
            value: 'married',
          },
          {
            label: 'Vienišas',
            value: 'single',
          },
          {
            label: 'Išsiskyręs(-usi)',
            value: 'divorced',
          },
          {
            label: 'Našlys(-ė)',
            value: 'widow',
          },
        ],
        visibleByRoleSlug: null,
      },
      {
        key: 'purpose',
        type: 'select',
        group: 'group-main',
        label: 'Paskolos tikslas',
        options: [
          {
            label: 'Atostogoms',
            value: 'vacation',
          },
          {
            label: 'Būsto remontui',
            value: 'renovation',
          },
          {
            label: 'Gydymui',
            value: 'medical',
          },
          {
            label: 'Prekėms ir paslaugoms',
            value: 'services',
          },
          {
            label: 'Studijoms',
            value: 'education',
          },
          {
            label: 'Kita',
            value: 'other',
          },
        ],
        visibleByRoleSlug: null,
      },
      {
        key: 'privacy_policy_agree',
        type: 'checkbox',
        group: 'group-main',
        label:
          'Susipažinau ir sutinku su Susitarimu dėl naudojimosi Finbro paslaugomis bei visomis jo sąlygomis, sutinku su UAB „Finbro“ privatumo politika.',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'workplace',
        type: 'string',
        group: 'group-main',
        label: 'Darbovietė',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'duties',
        type: 'string',
        group: 'group-main',
        label: 'Pareigos',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'documentExpiry',
        type: 'string',
        group: 'dsti_document',
        label: 'Dokumento galiojimo pabaiga',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'documentNumber',
        type: 'string',
        group: 'dsti_document',
        label: 'Dokumento numeris',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'documentType',
        type: 'select',
        group: 'dsti_document',
        label: 'Dokumento tipas',
        options: [
          {
            label: 'Asmens tapatybės kortelė',
            value: 'I',
          },
          {
            label: 'Pasas',
            value: 'P',
          },
        ],
        visibleByRoleSlug: null,
      },
      {
        key: 'address',
        type: 'string',
        group: 'dsti_common',
        label: 'Asmens deklaruota gyvenamoji vieta',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'bankAccount',
        type: 'string',
        group: 'dsti_common',
        label: 'Banko sąskaita',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'for_personal_needs',
        type: 'checkbox',
        group: 'group-main',
        label: 'Paskola reikalinga asmenimėms reikmėms',
        options: [],
        visibleByRoleSlug: null,
      },
    ],
  },
  {
    label: 'Paraiškos teikėjo sutuoktinis',
    items: [
      {
        key: 'is_married',
        type: 'checkbox',
        group: 'group-main',
        label: 'Ar turite sutuoktinį?',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'spouse_name',
        type: 'string',
        group: 'spouse',
        label: 'Sutuoktinio vardas',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'spouse_surname',
        type: 'string',
        group: 'spouse',
        label: 'Sutuoktinio pavardė',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'spouse_email',
        type: 'string',
        group: 'spouse',
        label: 'Sutuoktinio el. paštas',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'spouse_phone',
        type: 'string',
        group: 'spouse',
        label: 'Sutuoktinio telefonas',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'spouse_personcode',
        type: 'number',
        group: 'spouse',
        label: 'Sutuoktinio asmens kodas',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'spouse_monthly_income',
        type: 'number',
        group: 'spouse',
        label: 'Sutuoktinio pajamos per mėnesį',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'spouse_have_financial_liabilities',
        type: 'checkbox',
        group: 'group-main',
        label: 'Ar sutuoktinis turi įsipareigojimų finansinėms institucijoms?',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'spouse_financial_liabilities',
        type: 'number',
        group: 'group-main',
        label: 'Sutuoktinio įsipareigojimų suma',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'spouse_monthly_debit',
        type: 'number',
        group: 'spouse',
        label: 'Sutuoktinio įsipareigojimai finansų įstaigoms per mėnesį',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'spouse_workplace',
        type: 'string',
        group: 'spouse',
        label: 'Sutuoktinio darbovietė',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'spouse_duties',
        type: 'string',
        group: 'spouse',
        label: 'Sutuoktinio pareigos',
        options: [],
        visibleByRoleSlug: null,
      },
    ],
  },
  {
    label: 'Sutikimai',
    items: [
      {
        key: 'company_data_agree',
        type: 'checkbox',
        group: 'group-main',
        label: 'Sutinku gauti pasiūlymą tik iš UAB „Finbro“ ir mano asmens duomenų tvarkymu',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'compare_offers_agree',
        type: 'checkbox',
        group: 'group-shared',
        label:
          'Noriu palyginti įvairius pasiūlymus, sutinku su mano asmens duomenų perdavimu kitiems kredito davėjams ir mano asmens duomenų tvarkymu.',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'marketing_agree',
        type: 'checkbox',
        group: 'group-shared',
        label:
          'Sutinku, kad mano asmens duomenys būtų tvarkomi tiesioginės rinkodaros , įskaitant personalizuotų pasiūlymų teikimo, tikslais.',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'is_own_choice',
        type: 'checkbox',
        group: 'group-main',
        label: 'Ar savo noru sudarote sutartį ir pats naudositės finansinėmis paslaugomis?',
        options: [],
        visibleByRoleSlug: null,
      },
      {
        key: 'referral',
        type: 'string',
        group: 'group-main',
        label: 'Apie mus sužinojote',
        options: [],
        visibleByRoleSlug: ['ADMIN'],
        highlight: true,
      },
    ],
  },
]
